import { Route, Routes } from "react-router-dom";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";
import { OrganizationPoliciesEntryPage } from "~/entry-pages/organization/policies/OrganizationPoliciesEntryPage";
import { OrganizationPoliciesAddEntryPage } from "~/entry-pages/organization/policies/OrganizationPoliciesAddEntryPage";
import { OrganizationPoliciesAddDetailEntryPage } from "~/entry-pages/organization/policies/OrganizationPoliciesAddDetailEntryPage";
import { OrganizationPoliciesAddDetailChecksPage } from "~/pages/organization/policies-add/OrganizationPoliciesAddDetailChecksPage";
import { OrganizationPoliciesAddQueryDetailEntryPage } from "~/entry-pages/organization/policies/OrganizationPoliciesAddQueryDetailEntryPage";
import { OrganizationPolicyDetailEntryPage } from "~/entry-pages/organization/policies/OrganizationPolicyDetailEntryPage";
import { OrganizationPolicyOverviewTab } from "~/pages/organization/policy/tabs/OrganizationPolicyOverviewTab";
import { OrganizationPolicyChecksTab } from "~/pages/organization/policy/tabs/OrganizationPolicyChecksTab";
import { OrganizationPolicyExceptionsTab } from "~/pages/organization/policy/tabs/OrganizationPolicyExceptionsTab";
import { OrganizationPolicyPropertiesTab } from "~/pages/organization/policy/tabs/OrganizationPolicyPropertiesTab";
import { OrganizationCheckDetailPage } from "~/pages/organization/check/OrganizationCheckDetailPage";
import { OrganizationCheckResultsTab } from "~/pages/organization/check/tabs/OrganizationCheckResultsTab";
import { OrganizationCheckRemediationTab } from "~/pages/organization/check/tabs/OrganizationCheckRemediationTab";
import { OrganizationCheckDetailsTab } from "~/pages/organization/check/tabs/OrganizationCheckDetailsTab";

export function OrganizationPoliciesRoutes() {
  const { isFeatureEnabled } = useFeatureFlags();
  return (
    <Routes>
      <Route index element={<OrganizationPoliciesEntryPage />} />
      {isFeatureEnabled("Organization Policy Add") && (
        <Route path="/add">
          <Route index element={<OrganizationPoliciesAddEntryPage />} />
          <Route
            path=":policyId"
            element={<OrganizationPoliciesAddDetailEntryPage />}
          >
            <Route
              index
              element={<OrganizationPoliciesAddDetailChecksPage />}
            />
            <Route
              path="checks"
              element={<OrganizationPoliciesAddDetailChecksPage />}
            />
          </Route>
          <Route
            path=":policyId/queries/:queryId"
            element={<OrganizationPoliciesAddQueryDetailEntryPage />}
          />
        </Route>
      )}
      <Route path="/:policyId" element={<OrganizationPolicyDetailEntryPage />}>
        <Route index element={<OrganizationPolicyOverviewTab />} />
        <Route path="overview" element={<OrganizationPolicyOverviewTab />} />
        <Route path="checks" element={<OrganizationPolicyChecksTab />} />
        <Route
          path="exceptions"
          element={<OrganizationPolicyExceptionsTab />}
        />
        <Route
          path="properties"
          element={<OrganizationPolicyPropertiesTab />}
        />
      </Route>
      <Route path="/:policyId/check" element={<OrganizationCheckDetailPage />}>
        <Route index element={<OrganizationCheckResultsTab />} />
        <Route path="results" element={<OrganizationCheckResultsTab />} />
        <Route
          path="remediation"
          element={<OrganizationCheckRemediationTab />}
        />
        <Route path="details" element={<OrganizationCheckDetailsTab />} />
      </Route>
    </Routes>
  );
}
